import React, { useCallback } from "react";
import axios from "axios";
import moment from "moment";
import { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import Typography from "@material-ui/core/Typography";
import noImage from "../../assets/images/settings/no-image.png";
import "./profile.css";
import { Markup } from "interweave";
import QRCode from "react-qr-code";
import { serverInfo } from "../../App";
import getCroppedImg from "../Admin/Home/Pages/AddSuperStar/cropImage";
import { Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";
import Slider from "@material-ui/core/Slider";
import { styles } from "../Admin/Home/Pages/AddSuperStar/styles";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import useCoverChange from "../../CustomHooks/useCoverChange";
import useProfileChange from "../../CustomHooks/useProfileChange";

const Demo = ({classes}) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [user, setUser] = useState([]);
  const [starInfo, setStarInfo] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [profilePhoto, setProfilePhoto] = useState("");
  const [coverPhoto, setCoverPhoto] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const fileRef = useRef();
  const filePro = useRef();

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  // Cover Change
  const [croppedImage, setCroppedImage] = useState(null);
  const [coverDelKey, setCoverDelKey] = useState(null);
  const [coverUrl, coverKey, coverProgress] = useCoverChange(croppedImage, 'profile/superstar/cover', coverDelKey);

  // Profile Change
  const [profileCroppedImage, setProfileCroppedImage] = useState(null);
  const [profileDelKey, setProfileDelKey] = useState(null);
  const [profileUrl, profileKey, profileProgress] = useProfileChange(profileCroppedImage, 'profile/superstar/image', profileDelKey);

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info`).then((res) => {
        if (res.status === 200) {
          setUser(res.data.users);
          setStarInfo(res.data.star_details);
          setProfileImage(
            res.data.users.image !== null
              ? imageCdnUrl + res.data.users.image
              : noImage
          );
          setCoverPhoto(
            res.data.users.cover_photo !== null
              ? imageCdnUrl + res.data.users.cover_photo
              : noImage
          );
        }
      });
  }, []);

  // Update profile image when profileUrl changes from hook
  useEffect(() => {
    if (profileUrl) {
      setProfileImage(profileUrl);
    }
  }, [profileUrl]);

  // Update cover photo when coverUrl changes from hook
  useEffect(() => {
    if (coverUrl) {
      setCoverPhoto(coverUrl);
    }
  }, [coverUrl]);

  const handleCoverChange = (e) => {
    setCoverImage(e.target.files[0]);
    setCoverPhoto(URL.createObjectURL(e.target.files[0]));
  };

  const handleProfileChange = (e) => {
    setProfilePhoto(e.target.files[0]);
    setProfileImage(URL.createObjectURL(e.target.files[0]));
  };

  const coverSave = () => {
    setLoading1(true);
    const fData = new FormData();
    fData.append("cover_photo", coverKey || coverImage);

    axios.post(`/api/jury/juryUpdateCover/${user.id}`, fData).then((res) => {
      setLoading1(false);
      if (res.data.status == 200) {
        setCoverImage("");
        setCroppedImage(null);
        swal("Success", "Cover photo updated", "success");
      } else {
        swal("Error", "Failed to update cover photo", "error");
      }
    }).catch((err) => {
      setLoading1(false);
      swal("Error", err.message, "error");
    });
  };

  const profileSave = () => {
    setLoading2(true);
    const fData = new FormData();
    fData.append("image", profileKey || profilePhoto);

    axios.post(`/api/jury/juryUpdateProfile/${user.id}`, fData).then((res) => {
      setLoading2(false);
      if (res.data.status == 200) {
        setProfilePhoto("");
        setProfileCroppedImage(null);
        swal("Success", "Profile photo updated", "success");
      } else {
        swal("Error", "Failed to update profile photo", "error");
      }
    }).catch((err) => {
      setLoading2(false);
      swal("Error", err.message, "error");
    });
  };

  const [modalShow, setModalShow] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [profileModalShow, setProfileModalShow] = useState(false);
  const [profileCrop, setProfileCrop] = useState({ x: 0, y: 0 });
  const [profileZoom, setProfileZoom] = useState(1);
  const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] = useState(null);

  const handleProfileClose = () => setProfileModalShow(false);
  const handleShow = () => setModalShow(true);
  const handleClose = () => setModalShow(false);
  const handleProfileShow = () => setProfileModalShow(true);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const profileOnCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setProfileCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );

  // Convert data URL to Blob
  const dataUrlToBlob = (dataUrl, fileName) => {
    return new Promise((resolve) => {
      fetch(dataUrl).then(res => res.blob()).then(blob => {
        const file = new File([blob], fileName, { type: blob.type });
        resolve(file);
      });
    });
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImg = await getCroppedImg(
        coverPhoto,
        croppedAreaPixels,
      );
      // Convert data URL to Blob and pass to hook
      const croppedBlob = await dataUrlToBlob(croppedImg, `cover_${Date.now()}.png`);
      setCroppedImage(croppedBlob);
      setModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [coverPhoto, croppedAreaPixels]);

  const profileShowCroppedImage = useCallback(async () => {
    try {
      const profileCroppedImg = await getCroppedImg(
        profileImage,
        profileCroppedAreaPixels
      );
      // Convert data URL to Blob and pass to hook
      const profileCroppedBlob = await dataUrlToBlob(profileCroppedImg, `profile_${Date.now()}.png`);
      setProfileCroppedImage(profileCroppedBlob);
      setProfileModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [profileImage, profileCroppedAreaPixels]);

  return (
    <>
      <div className="row card-bg mx-1 py-3">
        <div className="col-md-12 custom-position-img">
          <div className="profile-container">
            {croppedImage ? (
              <img
                src={URL.createObjectURL(croppedImage)}
                className="img-fluid profile-cover mx-auto"
                alt="cover_photo"
              />
            ) : (
              <img
                src={coverPhoto ? coverPhoto : noImage}
                className="img-fluid profile-cover"
                alt="cover_photo"
              />
            )}
            {coverProgress > 0 && coverProgress < 100 && (
              <div className="progress" style={{ height: "5px" }}>
                <div 
                  className="progress-bar bg-info" 
                  style={{ width: `${coverProgress}%` }}
                />
              </div>
            )}
          </div>

          {croppedImage && (
            <>
              {loading1 ? (
                <button
                  className="btn btn-warning cover-po me-3"
                  onClick={coverSave}
                  disabled
                >
                  <i className="fas fa-spinner fa-pulse"></i> Saving...
                </button>
              ) : (
                <button
                  className="btn btn-warning cover-po me-3"
                  onClick={coverSave}
                >
                  <i className="far fa-save mx-1"></i> Save
                </button>
              )}
            </>
          )}

          <button className="bottomright" onClick={handleShow}>
            <i className="fa-solid fa-camera"></i>
          </button>

          <Modal
            show={modalShow}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div>
                <div className={classes.cropContainer}>
                  <Cropper
                    image={coverPhoto}
                    crop={crop}
                    zoom={zoom}
                    aspect={1250 / 450}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
                <div className={classes.controls}>
                  <div className={classes.sliderContainer}>
                    <Typography
                      variant="overline"
                      classes={{ root: classes.sliderLabel }}
                    >
                      Zoom
                    </Typography>
                    <Slider
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-labelledby="Zoom"
                      classes={{ root: classes.slider }}
                      onChange={(e, zoom) => setZoom(zoom)}
                    />
                  </div>

                  <input
                    accept="image/*"
                    ref={fileRef}
                    onChange={handleCoverChange}
                    multiple={false}
                    type="file"
                    hidden
                  />
                  <Button
                    onClick={showCroppedImage}
                    variant="contained"
                    color="primary"
                    classes={{ root: classes.cropButton }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={() => fileRef.current.click()}
                    variant="contained"
                    color="primary"
                    classes={{ root: classes.cropButton }}
                  >
                    Choose
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div className="profile-div mb-5">
            <div className="profile-photo">
              <div className="d-flex justify-content-center">
                {profileCroppedImage ? (
                  <img
                    src={URL.createObjectURL(profileCroppedImage)}
                    alt="profile"
                    className="img-fluid profile-img-pro"
                  />
                ) : (
                  <img
                    src={profileImage ? profileImage : noImage}
                    alt="profile"
                    className="img-fluid profile-img-pro"
                  />
                )}
              </div>

              {profileProgress > 0 && profileProgress < 100 && (
                <div className="progress" style={{ height: "5px", width: "100px", margin: "0 auto" }}>
                  <div 
                    className="progress-bar bg-success" 
                    style={{ width: `${profileProgress}%` }}
                  />
                </div>
              )}

              <button
                className="profile-pic-cam cam-po"
                onClick={handleProfileShow}
              >
                <i className="fa-solid fa-camera"></i>
              </button>

              {profileCroppedImage && (
                <>
                  {loading2 ? (
                    <button className="profile-pic-save rounded-3 mb-2" disabled>
                      <i className="fas fa-spinner fa-pulse"></i> Saving...
                    </button>
                  ) : (
                    <button
                      className="profile-pic-save cover-po rounded-3 mb-2"
                      onClick={profileSave}
                    >
                      Save
                    </button>
                  )}
                </>
              )}

              <Modal
                show={profileModalShow}
                onHide={handleProfileClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Body>
                  <div>
                    <div className={classes.cropContainer}>
                      <Cropper
                        image={profileImage}
                        crop={profileCrop}
                        zoom={profileZoom}
                        aspect={720 / 720}
                        onCropChange={setProfileCrop}
                        onCropComplete={profileOnCropComplete}
                        onZoomChange={setProfileZoom}
                      />
                    </div>
                    <div className={classes.controls}>
                      <div className={classes.sliderContainer}>
                        <Typography
                          variant="overline"
                          classes={{ root: classes.sliderLabel }}
                        >
                          Zoom
                        </Typography>
                        <Slider
                          value={profileZoom}
                          min={1}
                          max={3}
                          step={0.1}
                          aria-labelledby="Zoom"
                          classes={{ root: classes.slider }}
                          onChange={(e, profileZoom) => setProfileZoom(profileZoom)}
                        />
                      </div>

                      <input
                        accept="image/*"
                        ref={filePro}
                        onChange={handleProfileChange}
                        multiple={false}
                        type="file"
                        hidden
                      />
                      <Button
                        onClick={profileShowCroppedImage}
                        variant="contained"
                        color="primary"
                        classes={{ root: classes.cropButton }}
                      >
                        Save
                      </Button>
                      <Button
                        onClick={() => filePro.current.click()}
                        variant="contained"
                        color="primary"
                        classes={{ root: classes.cropButton }}
                      >
                        Choose
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>

        <center className="user-name-top">
          <div className="text-light fw-bold adm-name">
            {user.first_name} {user.last_name}
          </div>
          <small className="user-name-admin">{user?.userName}</small>
        </center>

        {user.user_type == "star" ? (
          <>
            <div className="co-md-6 my-4">
              <h5 className="text-warning fw-bold">Terms & Conditions</h5>
              <p className="text-light text-justify">
                <Markup content={starInfo?.terms_and_condition} />
              </p>
            </div>
            <div className="co-md-6 my-4">
              <h5 className="text-warning fw-bold">
                QR Code : {starInfo?.qr_code}
              </h5>
              <p className="text-light text-justify">
                <QRCode value={`${starInfo?.qr_code}`} />
              </p>
            </div>
          </>
        ) : null}

        <div className="row mt-5">
          <div className="col-md-4 mb-3 ">
            <div className="custom-card-profile">
              <div className="text-light p-2 px-3 fw-bold">
                Personal Information
              </div>
            </div>

            <div className="custom-card-profile-down px-3 p-2">
              <form>
                <div className="form-group mb-2">
                  <label className="text-light pb-1">Name</label>
                  <input
                    disabled
                    type="text"
                    className="form-control custom-pro-input"
                    placeholder={user.first_name + " " + user.last_name}
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="text-light pb-1">User Name</label>
                  <input
                    disabled
                    type="text"
                    className="form-control custom-pro-input"
                    placeholder={user.username}
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="text-light pb-1">Mail</label>
                  <input
                    disabled
                    type="email"
                    className="form-control custom-pro-input"
                    placeholder={user.email}
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="text-light pb-1">Phone</label>
                  <input
                    disabled
                    type="text"
                    className="form-control custom-pro-input"
                    placeholder={user.phone}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Profile = withStyles(styles)(Demo);
export default Profile;